export default "__VITE_ASSET__CrjPRYyi__"